// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1BnAG","header":"Messages_header__3fr7r"};